import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = ["addItem", "template"];

  connect() {
    this.form = this.element.closest("form");
    this.form.addEventListener("enter-pressed", this.addAssociation.bind(this));
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("enter-pressed", this.addAssociation.bind(this));
    }
  }

  addAssociation({ params: { associationReplaceTemplateRegex } }) {
    event.preventDefault();

    let templateDuplicate = this.templateTarget.cloneNode(true).innerHTML;

    if (associationReplaceTemplateRegex) {
      const uniqueId = new Date().getTime();
      templateDuplicate = templateDuplicate.replace(/TEMPLATE_RECORD/g, uniqueId);
    }

    this.addItemTarget.insertAdjacentHTML("beforebegin", templateDuplicate);
    const newElement = this.addItemTarget.previousElementSibling;

    newElement.querySelectorAll("[data-action='nested-form#addAssociation']").forEach((el) => {
      setTimeout(() => {
        el.click();
      }, 0); // Otherwise we trigger too early
    });

    if (this.addItemTarget.previousElementSibling.querySelector("input")) {
      this.addItemTarget.previousElementSibling.querySelector("input").focus();
    }
  }

  removeAssociation(event) {
    event.preventDefault();
    let item = event.target.closest(".js-nested-fields");
    item.querySelector("input.js-destroy-input").value = 1;
    item.querySelectorAll(".js-nested-field-to-remove").forEach((e) => e.remove());
    item.style.display = "none";

    this.element.dispatchEvent(new Event("nested-form:remove"));
  }
}
